// Filters
export const STORES = 'store';
export const SERVICE = 'service';
export const SUPERCHARGERS = 'supercharger';
export const DESTINATION_CHARGERS = 'destination charger';
export const DEFAULT = 'default';
export const FILTERS = [STORES, SERVICE, SUPERCHARGERS, DESTINATION_CHARGERS];

// Subtypes
export const GALLERY = 'gallery';
export const SALES_REP = 'salesRep';

// Unique identifier and query param for this version of findus.
export const VERSION = '2';
export const VERSION_PARAM = 'v';

// Map parameters.
export const MIN_ZOOM = 3;
export const DEFAULT_ZOOM = 11;
export const MAX_ZOOM = 22;
export const MAX_MARKER_ZOOM = 6;
export const DEFAULT_ZOOM_LEVELS = {
  country: 5,
  administrative_area_level_1: 7,
  administrative_area_level_2: 9,
  administrative_area_level_3: 10,
  locality: 12,
  colloquial_area: 12,
  route: 13,
  political: 13,
  postal_code: 13,
  embassy: 13,
  neighborhood: 14,
  street_address: 15,
  point_of_interest: 15,
  establishment: 15,
};
export const MAX_BOUNDS = {
  northeast: { lat: 85, lng: 180 },
  southwest: { lat: -85, lng: -180 },
};

// Marker constants.
export const ICON_TYPES = {
  dot: 'dot',
  selected: 'selected',
  upcoming: 'upcoming',
  default: 'default',
};

// Get content key by location type.
export const LOCATION_CONTENT_KEY = {
  store: 'store',
  gallery: 'gallery',
  salesRep: 'salesRepresentative',
  service: 'service',
  supercharger: 'supercharger',
  'destination charger': 'destinationCharger',
};

// Location types to show primary CTA for.
export const PRIMARY_LOCATION_TYPES = [STORES];

// Breakpoints and other view related constants.
export const MOBILE = 840;
export const HEADER = 52;

// Image asset url
export const RESOURCE_BASE_URL =
  process.env.NODE_ENV !== 'development' ? window.tesla.resourceBaseUrl : '';

export const { API_BASE_URL } = process.env;
